export default {
  methods: {
    $getSeoHead(key, country = '', gameName = '') {
      const { $i18n } = this
      const titleKey = `seo.${key}.title`
      const descKey = `seo.${key}.description`
      const keywordsKey = `seo.${key}.keywords`
      const result = {
        meta: [],
        __dangerouslyDisableSanitizersByTagID: {
          description: ['content'],
        },
        link: [
          {
            rel: 'canonical',
            href: `https://www.toplupe.com/${country}/${gameName}`,
          },
        ],
        // __dangerouslyDisableSanitizers: ['meta'],
      }
      const title = $i18n.te(titleKey) ? $i18n.t(titleKey) : ''
      const description = $i18n.te(descKey) ? $i18n.t(descKey) : ''
      const keywords = $i18n.te(keywordsKey) ? $i18n.t(keywordsKey) : ''

      if (title && title !== titleKey) {
        result.title = title
      }

      if (description && description !== descKey) {
        result.meta.push({
          hid: 'description',
          name: 'description',
          content: description,
        })
      }

      if (keywords && keywords !== keywordsKey) {
        result.meta.push({
          hid: 'keywords',
          name: 'keywords',
          content: keywords,
        })
      }

      return result
    },
  },
}
